export default __webpack_public_path__ + "img/11bfad553d83ad45394d96d98db04564.svg";